module.exports = __webpack_public_path__ + "fe947fe1ec536eba295b75075b91dbcc.svg";